<template>
  <div class="records">
    <div class="record-header">
      <w-tabs :header-nav-style="{paddingLeft: '24px'}" v-model="activeName" @tab-click="tabHandle">
        <w-tab-pane label="工程项目" name="engineering"></w-tab-pane>
        <w-tab-pane label="数据操作" name="data"></w-tab-pane>
        <!-- <w-tab-pane label="企业管理" name="company"></w-tab-pane> -->
      </w-tabs>
    </div>
    <div class="record-content">
      <project :isactive="activeName === 'engineering'"></project>
      <datar :isactive="activeName === 'data'"></datar>
      <!-- <company-manage :isactive="activeName === 'company'"></company-manage> -->
    </div>
  </div>
</template>

<script>
import project from './children/project'
import datar from './children/data'
import companyManage from './children/company-manage'

export default {
  name: 'recordsIndex',
  components: {
    project,
    datar,
    companyManage
  },
  data () {
    return {
      activeName: 'engineering'
    }
  },
  mounted () {
    this.sentLog(100107071)
  },
  methods: {
    tabHandle ({name}) {
      if (name === 'engineering') {
        this.sentLog(100107071)
      } else if (name === 'data') {
        this.sentLog(100107072)
      } else {
        this.sentLog(100107079)
      }
      this.activeName = name
    }
  }
}
</script>

<style lang=less>
  .records {
    margin-left: 10px;
    overflow: hidden;
    position: relative;
    top: 0;
    left: 0;
    height: 100%;

    table {
      table-layout: fixed;
      word-break: break-all;
    }

    .sort {
      position: relative;
      top: 2px;
      left: 5px;
      display: inline-block;
      width: 8px;
      height: 12px;
      background: transparent url('~@/assets/images/sort.png') 0 0 no-repeat;
    }

    .sort-down {
      position: relative;
      top: 2px;
      left: 5px;
      display: inline-block;
      width: 8px;
      height: 12px;
      background: transparent url('~@/assets/images/sort.png') -22px 0 no-repeat;
    }

    .sort-up {
      position: relative;
      top: 2px;
      left: 5px;
      display: inline-block;
      width: 8px;
      height: 12px;
      background: transparent url('~@/assets/images/sort.png') -11px 0 no-repeat;
    }

    .empty-box {
      position: absolute;
      top: 100px;
      text-align: center;
      width: 100%;
      left: 0px;
      font-size: 26px;
      color: #999;
    }

    .table-body-wrapper {
      top: -47px !important;
    }

    .position-relative {
      position: relative;
      cursor: pointer;
    }

    .sanjao-group {
      position: absolute;
      right: -15px;
      bottom: -5px;
      color: #666;
      font-size: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      transform: scale(0.8);
      height: 30px;
      transform: scale(0.6);
      height: 25px;

      .sanjiao {
        font-size: 8px;
      }

      .sanjiao1 {
        font-size: 8px;
      }

      .sanjiao2 {
        font-size: 8px;
        position: relative;
        top: -6px;
      }

      .active {
        color: #72a700;
      }
    }

    .table-body-wrapper tr {
      height: 46px;
    }

    .datepicker {
      input {
        box-shadow: inset 0 0 0 1000px #fff !important;
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: 14px;
        height: 32px;
        line-height: 32px;
        outline: none;
        padding: 0 15px;
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        width: 100%;
      }
    }

    .page-box {
      position: absolute;
      padding-right: 24px;
      bottom: 10px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .search-line {
      margin-bottom: 15px;
    }

    .search-item {
      display: inline-block;
    }

    .search-item-1 {
      width: 186px;

      input {
        width: 120px;
      }
    }

    .label {
      width: 50px;
    }

    label {
      width: 84px;
      display: inline-block;
      text-align: right;
      margin-right: 10px;
      font-size: 14px;
      color: #666;
    }


    select {
      font-size: 12px;
      height: 26px;
      color: #666;
      border: 1px solid #d8d8d8;
    }

    .record-button {
      cursor: pointer;
      width: 66px;
      height: 28px;
      color: #fff;
      text-align: center;
      font-size: 14px;
      border: none;
      border-radius: 5px;
      background: #2389ed;
      margin-left: 20px;
    }

    .record-header {
      padding: 24px 0px 9px 0px;
      line-height: 30px;
      height: 87px;
      box-sizing: border-box;

      &::before {
        content: '';
        display: table;
        height: 0;
      }
    }

    .record-content {
      height: calc(100% - 87px);
      .record-wrapper {
        height: 100%;
        .search-box {
          height: 95px;
        }
        .table-box {
          height: calc(100% - 95px);
        }
        .table-box-page{
          height: calc(100% - 140px);
          overflow: hidden;
        }
      }
    }

    .record-nav {
      border-bottom: 1px solid #cccccc;
      height: 36px;
      margin-bottom: 7px;
      line-height: 30px;

      .record-tab {
        display: inline-block;
        width: 135px;
        text-align: center;
        font-size: 16px;
        color: #747474;
        cursor: pointer;
        box-sizing: border-box;
      }

      .active {
        border-right: 1px solid #cccccc;
        border-left: 1px solid #cccccc;
        border-top: 2px solid #1b6cbb;
        line-height: 34px;
        background: #fff;
        border-bottom: 1px solid #fff;
      }
    }
  }
  .search-box input {
    height: 32px;
    border: 1px solid #d8d8d8;
    font-size: 12px;
    padding: 0px 10px;
    width: 180px;
    vertical-align: baseline;
    outline: 0;
  }

</style>
